import { Directive, ElementRef, HostListener } from '@angular/core';
import { DsdRadio } from '@dsd/library-angular';

@Directive({
  selector: '[dsdExtRadioGroupChild], dsd-radio',
  standalone: false
})
export class RadioGroupChildDirective {
  @HostListener('dsdRadioChange', ['$event.detail.value'])
  onValueChange;

  private radio: DsdRadio;

  set checked(value: boolean) {
    this.radio.checked = value;
  }

  get value() {
    return this.radio.value;
  }

  constructor(readonly elementRef: ElementRef<DsdRadio>) {
    this.radio = elementRef.nativeElement;
  }
}
